import { fetchWrapper } from "../utils/fetch-wrapper";

const sitesSerivces = {
  getAll,
  getById,
  getByUuid,
  post,
  update,
  delete: _delete,
};

function getAll(
  env_client_id: any = "",
  type_espace: string = "",
  typologie_piece: string = "",
  nom_adresse_bâtiment: string = ""
) {
  const queryParams: Record<string, any> = {};
  if (type_espace !== "") {
    queryParams.type_espace = type_espace;
  }

  if (typologie_piece !== "") {
    queryParams.typologie_piece = typologie_piece;
  }

  if (nom_adresse_bâtiment !== "") {
    queryParams.nom_adresse_bâtiment = nom_adresse_bâtiment;
  }
  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }
  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");

  return fetchWrapper.get(`sites/?${queryString}`);
}

function getById(id) {
  return fetchWrapper.get(`sites/${id}`);
}

function getByUuid(uuid) {
  return fetchWrapper.get(`sites/${uuid}`);
}

function post(data) {
  return fetchWrapper.post("sites/", data);
}

function update(id, params) {
  return fetchWrapper.put(`sites/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`sites/${id}`);
}

export default sitesSerivces;
